export const environment = {
  name: 'prod',
  production: true,
  hmr: false,
  firebase: {
    apiKey: "AIzaSyB0vJlNvXEvpe5kMKxAqvii5-CBrqs-5_Q",
    authDomain: "genius-repair.firebaseapp.com",
    databaseURL: "https://genius-repair.firebaseio.com",
    projectId: "genius-repair",
    storageBucket: "genius-repair.appspot.com",
    messagingSenderId: "23746740914",
    appId: "1:23746740914:web:90aa8e63d04fbe51193fab",
    measurementId: "G-TT8YTXNGEX"
  },
  defaultDialingCode: '+39',
  qrCodeUrlBase: 'https://qr.geniusrepair.it/o/',
  sellaPosUrl: 'https://k8s.fp8.app/genius-repair/d/1/',
  uploadDirectory: 'uploads/',
  skipPayment: false,
  covercareLabId: "LWTE87DNZIywoZGyhHh9",
  termsAndConditionLink: 'https://firebasestorage.googleapis.com/v0/b/genius-repair.appspot.com/o/Genius-privacy-policy.pdf?alt=media',
  termsAndConditionLinkCovercare: 'https://firebasestorage.googleapis.com/v0/b/genius-repair.appspot.com/o/GENIUSCare_Privacy-Regolamento_Riparazione.pdf?alt=media',
  termsAndConditionLinkKasko: 'https://firebasestorage.googleapis.com/v0/b/genius-repair.appspot.com/o/GENIUSCare_Privacy-Regolamento_KASKO.pdf?alt=media',
  comuniItalianiAPI: 'https://comuni-ita.herokuapp.com/api/',
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts